<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper" v-if="order">
    <!-- MOBILE VIEW -->
    <div class="content d-lg-none mob-po-detail p-0">
        <!-- Sticky Header -->
        <div class="mob-detail-header px-3 py-3 bg-white shadow-sm sticky-top">
           <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center gap-3">
                 <a href="javascript:void(0);" @click="router.push('/purchases/order-list')" class="btn-back-mob shadow-sm">
                    <vue-feather type="arrow-left" size="20"></vue-feather>
                 </a>
                 <div>
                    <h5 class="fw-bold mb-0">Detail PO #{{ order.id }}</h5>
                    <small class="text-muted">{{ formatDate(order.tanggal_order) }}</small>
                 </div>
              </div>
               <div class="d-flex align-items-center gap-2">
                  <span :class="statusBadgeClass(calculatedStatus)" class="uppercase">{{ calculatedStatus }}</span>
                  <button v-if="$hasPermission('ssp', 'orders', 'delete')" class="btn-delete-mob shadow-sm" @click="deleteOrder">
                     <vue-feather type="trash-2" size="18"></vue-feather>
                  </button>
               </div>
            </div>
         </div>

        <!-- Content Area -->
        <div class="px-3 pt-3 pb-5">
           <!-- Quick Actions -->
           <div class="d-flex gap-2 mb-4" v-if="order.status === 'draft'">
              <button class="btn btn-dark flex-fill rounded-pill py-2 fw-bold" @click="finalizeOrder">
                 <vue-feather type="check-circle" size="16" class="me-1"></vue-feather> Finalisasi
              </button>
           </div>

           <!-- Kios Info Card -->
           <div class="mob-card bg-white shadow-xs mb-4">
              <div class="d-flex align-items-center gap-3 mb-3">
                 <div class="kios-avatar bg-success-soft text-success">
                    <vue-feather type="home" size="20"></vue-feather>
                 </div>
                 <div class="flex-fill">
                    <h6 class="fw-bold mb-0 text-dark">{{ order.member_toko || '-' }}</h6>
                    <small class="text-muted">{{ order.member_nama || '-' }}</small>
                 </div>
                 <router-link :to="'/people/kios-details/' + order.member_id" class="btn btn-light btn-sm rounded-pill">
                    <vue-feather type="external-link" size="14"></vue-feather>
                 </router-link>
              </div>
              <div class="text-muted small">
                 {{ order.member_alamat || '-' }}
              </div>
           </div>

           <!-- Catatan -->
           <div class="mb-4">
              <label class="smallest fw-800 text-muted uppercase tracking-wider mb-2 d-block">CATATAN PO</label>
              <textarea 
                 class="form-control mob-textarea" 
                 v-model="catatanLocal" 
                 @blur="saveNotes"
                 placeholder="Tambah catatan..."
                 rows="2"
              ></textarea>
              <small v-if="isSavingNotes" class="text-success mt-1 d-block">Menyimpan...</small>
           </div>

           <!-- Progres Realisasi -->
           <div class="mb-4">
              <div class="d-flex justify-content-between align-items-center mb-3">
                 <label class="smallest fw-800 text-dark uppercase tracking-wider">PROGRES REALISASI</label>
                 <button v-if="order.status !== 'completed'" @click="openShipmentModal" class="btn-add-pill bg-primary text-white">
                    <vue-feather type="plus" size="14" class="me-1"></vue-feather>
                    INPUT
                 </button>
              </div>
              
              <div v-for="item in orderItems" :key="'mob-item-'+item.id" class="mob-progress-card bg-white shadow-xs mb-2">
                 <div class="d-flex justify-content-between align-items-start mb-2">
                    <div>
                       <span class="fw-bold text-dark text-uppercase small">{{ item.product_nama }}</span>
                       <div class="text-muted smallest">Sumber: {{ item.source_nama }}</div>
                    </div>
                    <span class="badge rounded-pill smallest" :class="item.progress_percent >= 100 ? 'bg-success' : 'bg-primary'">{{ item.progress_percent }}%</span>
                 </div>
                 <div class="progress" style="height: 6px;">
                    <div class="progress-bar" :class="item.progress_percent >= 100 ? 'bg-success' : 'bg-primary'" :style="{ width: item.progress_percent + '%' }"></div>
                 </div>
                  <div class="d-flex justify-content-between mt-2 smallest text-muted">
                     <span>Pesan: <strong class="text-dark">{{ item.quantity_box }} <span class="uppercase">{{ item.qty_type }}</span></strong></span>
                     <span>Kirim: <strong :class="item.qty_shipped >= item.quantity_box ? 'text-success' : 'text-primary'">{{ item.qty_shipped }}</strong></span>
                  </div>
              </div>
           </div>

           <!-- Riwayat Pengiriman -->
           <div class="mb-4">
              <label class="smallest fw-800 text-dark uppercase tracking-wider mb-3 d-block">RIWAYAT PENGIRIMAN</label>
              
              <div v-if="shipments.length > 0">
                 <div v-for="s in shipments" :key="'mob-ship-'+s.id" class="mob-history-card bg-white shadow-xs mb-3">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                       <span class="small fw-bold text-dark">{{ formatDateShort(s.tanggal_pengiriman) }}</span>
                       <span class="badge bg-light text-primary smallest">{{ s.source_nama }}</span>
                    </div>
                    <div class="text-muted smallest mb-2">No SJ: {{ s.no_surat_jalan || '-' }}</div>
                    
                    <div class="bg-light bg-opacity-50 rounded-3 p-2 mb-2" v-if="s.items && s.items.length > 0">
                       <div v-for="si in s.items" :key="si.id" class="d-flex justify-content-between smallest py-1 text-dark">
                          <span>{{ si.product_nama }}</span>
                          <span class="fw-bold">{{ si.qty_shipped }} <span class="uppercase">{{ si.qty_type || 'Dus' }}</span></span>
                       </div>
                    </div>

                     <div v-if="s.notes" class="bg-success bg-opacity-10 rounded-3 p-2 mb-2 smallest italic" style="color: #000 !important;">
                        "{{ s.notes }}"
                     </div>

                    <div class="text-end">
                       <button class="btn btn-link btn-sm text-danger p-0 smallest" @click="removeShipment(s.id)">Hapus</button>
                    </div>
                 </div>
              </div>
              <div v-else class="text-center py-4 bg-light rounded-4">
                 <vue-feather type="truck" class="text-muted mb-2" size="32"></vue-feather>
                 <p class="text-muted small mb-0">Belum ada riwayat pengiriman</p>
              </div>
           </div>
        </div>
    </div>

    <!-- DESKTOP VIEW -->
    <div class="content d-none d-lg-block">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Detail PO #{{ order.id }}</h4>
            <h6><router-link to="/purchases/purchase-list">Daftar PO</router-link> / Detail</h6>
          </div>
        </div>
        <div class="page-btn d-flex gap-2">
            <button v-if="order.status === 'draft' && $hasPermission('ssp', 'orders', 'edit')" class="btn btn-black" @click="finalizeOrder">
                <i data-feather="check-circle" class="me-2"></i>Finalisasi
            </button>
            <button v-if="$hasPermission('ssp', 'orders', 'delete')" class="btn btn-outline-danger" @click="deleteOrder">
                <i data-feather="trash-2" class="me-2"></i>Hapus PO
            </button>
            <router-link to="/purchases/purchase-list" class="btn btn-outline-secondary">
                <i data-feather="arrow-left" class="me-2"></i>Kembali
            </router-link>
        </div>
      </div>

      <div class="row">
        <!-- Info Cards -->
        <div class="col-lg-4 mb-4">
            <div class="card h-100 shadow-sm border-0">
                <div class="card-header bg-white py-3">
                    <h5 class="card-title mb-0 d-flex align-items-center">
                        <span>Info PO</span>
                    </h5>
                </div>
                <div class="card-body p-0">
                    <table class="table table-borderless mb-0">
                        <tr class="border-bottom">
                            <td class="ps-4 py-3 text-muted small text-uppercase fw-bold">ID PO</td>
                            <td class="pe-4 py-3 text-end"><span class="badge bg-light text-primary">#{{ order.id }}</span></td>
                        </tr>
                        <tr class="border-bottom">
                            <td class="ps-4 py-3 text-muted small text-uppercase fw-bold">Tanggal</td>
                            <td class="pe-4 py-3 text-end fw-semibold">{{ formatDate(order.tanggal_order) }}</td>
                        </tr>
                        <tr class="border-bottom">
                            <td class="ps-4 py-3 text-muted small text-uppercase fw-bold">Status</td>
                            <td class="pe-4 py-3 text-end">
                                <span :class="statusBadgeClass(calculatedStatus)">{{ calculatedStatus.toUpperCase() }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="ps-4 pe-4 py-3">
                                <label class="text-muted small text-uppercase fw-bold d-block mb-1">Catatan</label>
                                <textarea 
                                    class="form-control border-dashed bg-white text-dark" 
                                    v-model="catatanLocal" 
                                    @blur="saveNotes"
                                    placeholder="Tambah catatan..."
                                    rows="3"
                                    style="color: #000 !important;"
                                ></textarea>
                                <small v-if="isSavingNotes" class="text-primary mt-1 d-block">
                                    <i class="fas fa-spinner fa-spin me-1"></i>Menyimpan...
                                </small>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>

        <div class="col-lg-8 mb-4">
            <div class="card h-100 shadow-sm border-0">
                <div class="card-header bg-white py-3">
                    <h5 class="card-title mb-0 d-flex align-items-center">
                        <span>Info Kios</span>
                    </h5>
                </div>
                <div class="card-body">
                    <div class="row g-4">
                        <div class="col-md-6">
                            <label class="text-muted small text-uppercase fw-bold d-block mb-1">Nama Toko</label>
                            <router-link :to="'/people/kios-details/' + order.member_id">
                                <h5 class="fw-bold mb-0 text-success">{{ order.member_toko || '-' }}</h5>
                            </router-link>
                        </div>
                        <div class="col-md-6">
                            <label class="text-muted small text-uppercase fw-bold d-block mb-1">Nama Pemilik</label>
                            <router-link :to="'/people/kios-details/' + order.member_id">
                                <h5 class="fw-bold mb-0 text-danger">{{ order.member_nama || '-' }}</h5>
                            </router-link>
                        </div>
                        <div class="col-md-6">
                            <label class="text-muted small text-uppercase fw-bold d-block mb-1">Alamat</label>
                            <div class="text-muted small">{{ order.member_alamat || '-' }}</div>
                        </div>
                        <div class="col-md-6">
                            <label class="text-muted small text-uppercase fw-bold d-block mb-1">Nomor HP</label>
                            <div class="text-success small fw-bold">{{ order.member_handphone || '-' }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>

      <div class="row">
        <!-- Progress Table -->
        <div class="col-lg-8 mb-4">
            <div class="card shadow-sm border-0 h-100">
                <div class="card-header bg-white py-3 d-flex justify-content-between align-items-center">
                    <h5 class="card-title mb-0 d-flex align-items-center">
                        <span>Progres Realisasi Kirim</span>
                    </h5>
                    <button v-if="order.status !== 'completed'" class="btn btn-sm btn-primary py-2 px-3" @click="openShipmentModal">
                        Input Realisasi Kirim
                    </button>
                </div>
                <div class="card-body p-0">
                    <div class="table-responsive">
                        <table class="table table-hover mb-0">
                            <thead class="bg-light">
                                <tr>
                                    <th class="ps-4">Produk</th>
                                    <th class="text-center">Pesan</th>
                                    <th class="text-center">Kirim</th>
                                    <th>Progress</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in orderItems" :key="item.id">
                                    <td class="ps-4">
                                        <strong>{{ item.product_nama }}</strong><br>
                                        <small class="text-muted">Sumber: {{ item.source_nama }}</small>
                                    </td>
                                     <td class="text-center">
                                         {{ item.quantity_box }}
                                         <small class="text-muted d-block uppercase" style="font-size: 10px;">{{ item.qty_type }}</small>
                                     </td>
                                    <td class="text-center">
                                        <span :class="item.qty_shipped >= item.quantity_box ? 'text-success' : 'text-primary'" class="fw-bold">
                                            {{ item.qty_shipped }}
                                        </span>
                                    </td>
                                    <td>
                                        <div class="d-flex align-items-center">
                                            <div class="progress flex-grow-1 me-2" style="height: 6px;">
                                                <div class="progress-bar" :class="item.progress_percent >= 100 ? 'bg-success' : 'bg-primary'" :style="{ width: item.progress_percent + '%' }"></div>
                                            </div>
                                            <small class="fw-bold">{{ item.progress_percent }}%</small>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- Shipment History -->
        <div class="col-lg-4 mb-4">
            <div class="card shadow-sm border-0 h-100">
                <div class="card-header bg-white py-3">
                    <h5 class="card-title mb-0 d-flex align-items-center">
                        <vue-feather type="clock" class="me-2 text-primary"></vue-feather>
                        <span>Riwayat Pengiriman</span>
                    </h5>
                </div>
                <div class="card-body p-0">
                    <div class="list-group list-group-flush" v-if="shipments.length > 0">
                        <div v-for="s in shipments" :key="s.id" class="list-group-item p-3">
                            <div class="d-flex justify-content-between mb-1">
                                <span class="fw-bold small">{{ formatDate(s.tanggal_pengiriman) }}</span>
                                <span class="badge bg-light text-primary">{{ s.source_nama }}</span>
                            </div>
                            <div class="small text-muted mb-2">No SJ: {{ s.no_surat_jalan || '-' }}</div>
                            
                            <!-- Display Items in this shipment -->
                            <div class="bg-light bg-opacity-50 p-2 rounded mb-2" v-if="s.items && s.items.length > 0">
                                <div v-for="si in s.items" :key="si.id" class="d-flex justify-content-between x-small py-1 border-bottom border-white text-dark">
                                    <span>{{ si.product_nama }}</span>
                                    <span class="fw-bold">{{ si.qty_shipped }} <span class="uppercase">{{ si.qty_type || 'Dus' }}</span></span>
                                </div>
                            </div>

                             <div v-if="s.notes" class="mt-2 p-2 bg-success bg-opacity-10 rounded small">
                                 <span class="fw-bold d-block small text-success mb-1 text-uppercase" style="font-size: 9px;">Catatan:</span>
                                 <span class="italic" style="color: #000 !important;">"{{ s.notes }}"</span>
                             </div>
                            <div class="mt-2 text-end">
                                <button class="btn btn-link btn-sm text-danger p-0" @click="removeShipment(s.id)">Hapus</button>
                            </div>
                        </div>
                    </div>
                    <div v-else class="p-4 text-center text-muted">
                        <p>Belum ada riwayat pengiriman.</p>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Shipment Modal (Mobile Fullscreen) -->
  <div class="modal fade" id="shipment-modal" tabindex="-1">
    <div class="modal-dialog modal-lg modal-fullscreen-md-down">
        <div class="modal-content border-0">
            <div class="modal-header border-0 pb-0">
               <div class="d-flex align-items-center gap-3">
                  <button type="button" class="btn-close-mob d-md-none" data-bs-dismiss="modal" ref="modalCloseBtn">
                     <vue-feather type="x" size="20"></vue-feather>
                  </button>
                  <h5 class="fw-bold mb-0">Input Realisasi Kirim</h5>
               </div>
               <button type="button" class="btn-close d-none d-md-block" data-bs-dismiss="modal" ref="modalCloseBtn"></button>
            </div>
            <div class="modal-body p-4" v-if="order">
                <div class="row mb-3">
                    <div class="col-md-6 mb-3 mb-md-0">
                        <label class="form-label mob-label">Tanggal Pengiriman</label>
                        <div class="input-group themed-datepicker">
                            <span class="input-group-text bg-white border-end-0">
                                <vue-feather type="calendar" style="width: 16px; height: 16px;"></vue-feather>
                            </span>
                            <a-date-picker 
                                v-model:value="shipmentForm.tanggal_pengiriman" 
                                placeholder="Pilih Tanggal" 
                                class="form-control border-start-0 custom-date-input"
                                value-format="YYYY-MM-DD"
                                :getPopupContainer="(trigger) => trigger.parentNode"
                            />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label mob-label">Sumber Barang</label>
                        <select class="form-select mob-select" v-model="shipmentForm.source_id">
                            <option value="">Pilih Sumber...</option>
                            <option v-for="s in orderSources" :key="s.id" :value="s.id">{{ s.text }}</option>
                        </select>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-6 mb-3 mb-md-0">
                        <label class="form-label mob-label">No. Surat Jalan</label>
                        <input type="text" class="form-control mob-input" v-model="shipmentForm.no_surat_jalan" placeholder="SJ-..." />
                    </div>
                    <div class="col-md-6">
                        <label class="form-label mob-label">Catatan</label>
                        <textarea class="form-control mob-input" v-model="shipmentForm.notes" rows="1" placeholder="Tambahkan catatan..."></textarea>
                    </div>
                </div>

                <div class="mt-4">
                    <label class="form-label mob-label mb-3">PRODUK YANG DIKIRIM</label>
                    <div v-if="!shipmentForm.source_id" class="text-center py-4 bg-light rounded-4">
                       <vue-feather type="alert-circle" class="text-muted mb-2" size="24"></vue-feather>
                       <p class="text-muted small mb-0">Pilih Sumber Barang terlebih dahulu</p>
                    </div>
                    <div v-else-if="filteredItemsForShipment.length === 0" class="text-center py-4 bg-danger bg-opacity-10 rounded-4">
                       <vue-feather type="check-circle" class="text-success mb-2" size="24"></vue-feather>
                       <p class="text-success small mb-0 fw-bold">Semua item dari sumber ini sudah terkirim</p>
                    </div>
                    <div v-else>
                       <div v-for="item in filteredItemsForShipment" :key="'ship-item-'+item.id" class="mob-ship-item bg-light rounded-4 p-3 mb-2">
                          <div class="d-flex justify-content-between align-items-center">
                             <div class="flex-fill">
                                <span class="fw-bold text-dark small">{{ item.product_nama }}</span>
                                <div class="text-muted smallest">Sisa: {{ item.remaining }} <span class="uppercase">{{ item.qty_type || 'Dus' }}</span></div>
                             </div>
                             <div class="d-flex align-items-center gap-2">
                                <input 
                                   type="number" 
                                   class="form-control mob-qty-input text-center" 
                                   v-model.number="item.input_qty" 
                                   min="0" 
                                   :max="item.remaining"
                                   @input="validateQty(item)"
                                   style="width: 70px;"
                                />
                                <span class="text-muted smallest uppercase">{{ item.qty_type || 'Dus' }}</span>
                             </div>
                          </div>
                       </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer border-0 px-4 pb-4">
                <button type="button" class="btn btn-light rounded-pill flex-fill d-md-none" data-bs-dismiss="modal">Batal</button>
                <button type="button" class="btn btn-secondary d-none d-md-block" data-bs-dismiss="modal">Tutup</button>
                <button type="button" class="btn btn-success rounded-pill flex-fill flex-md-grow-0 fw-bold" @click="saveShipment" :disabled="isSavingShipment">
                    <vue-feather v-if="isSavingShipment" type="loader" size="16" class="me-1 spin"></vue-feather>
                    SIMPAN REALISASI
                </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed, reactive } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import orderService from '@/services/orderService';
import shipmentService from '@/services/shipmentService';
import Swal from 'sweetalert2';

export default {
  setup() {
    const route = useRoute();
    const router = useRouter();
    const orderId = route.params.id;
    
    const order = ref(null);
    const orderItems = ref([]);
    const shipments = ref([]);
    const isSavingShipment = ref(false);
    const catatanLocal = ref("");
    const isSavingNotes = ref(false);

    const shipmentForm = reactive({
        tanggal_pengiriman: new Date().toISOString().split('T')[0],
        source_id: "",
        no_surat_jalan: "",
        notes: ""
    });

    const loadData = async () => {
        try {
            const data = await orderService.getOrder(orderId);
            order.value = data;
            catatanLocal.value = data.catatan || "";
            
            // Get shipments to calculate progress
            const shipData = await shipmentService.getShipmentsByOrder(orderId);
            shipments.value = shipData;

            // Recalculate item progress manually in frontend (since we analyzed this gap in FastAPI)
            const shippedMap = {};
            shipData.forEach(ship => {
                ship.items.forEach(si => {
                    if (!shippedMap[si.order_detail_id]) shippedMap[si.order_detail_id] = 0;
                    shippedMap[si.order_detail_id] += si.qty_shipped;
                });
            });

            orderItems.value = (data.details || []).map(d => {
                const qShipped = shippedMap[d.id] || 0;
                return {
                    ...d,
                    qty_shipped: qShipped,
                    remaining: d.quantity_box - qShipped,
                    progress_percent: Math.round((qShipped / d.quantity_box) * 100),
                    input_qty: 0 // for form
                };
            });

        } catch (error) {
            console.error("Failed to load order detail", error);
            Swal.fire('Error', 'Gagal memuat data PO', 'error');
        }
    };

    const saveNotes = async () => {
        if (catatanLocal.value === order.value.catatan) return;
        
        isSavingNotes.value = true;
        try {
            await orderService.updateOrder(orderId, { catatan: catatanLocal.value });
            order.value.catatan = catatanLocal.value;
            
            const toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true
            });
            toast.fire({ icon: 'success', title: 'Catatan diperbarui' });
        } catch (error) {
            Swal.fire('Error', 'Gagal menyimpan catatan', 'error');
        } finally {
            isSavingNotes.value = false;
        }
    };

    const calculatedStatus = computed(() => {
        if (!order.value) return 'draft';
        if (order.value.status === 'draft') return 'draft';
        
        const totalItems = orderItems.value.length;
        if (totalItems === 0) return order.value.status;

        const totalShippedPercent = orderItems.value.reduce((acc, item) => acc + item.progress_percent, 0) / totalItems;
        
        if (totalShippedPercent === 0) return 'processing';
        if (totalShippedPercent < 100) return 'partial';
        return 'completed';
    });

    onMounted(loadData);

    const orderSources = computed(() => {
        const sources = [];
        const seen = new Set();
        orderItems.value.forEach(item => {
            if (!seen.has(item.source_id)) {
                seen.add(item.source_id);
                sources.push({ id: item.source_id, text: item.source_nama });
            }
        });
        return sources;
    });

    const filteredItemsForShipment = computed(() => {
        if (!shipmentForm.source_id) return [];
        return orderItems.value.filter(item => item.source_id == shipmentForm.source_id && item.remaining > 0);
    });

    const validateQty = (item) => {
        // Clamp value to 0 - remaining
        if (item.input_qty < 0) {
            item.input_qty = 0;
        } else if (item.input_qty > item.remaining) {
            item.input_qty = item.remaining;
        }
    };

    const saveShipment = async () => {
        const itemsToShip = filteredItemsForShipment.value
            .filter(i => i.input_qty > 0)
            .map(i => ({
                order_detail_id: i.id,
                product_id: i.product_id,
                qty_shipped: parseInt(i.input_qty)
            }));

        if (itemsToShip.length === 0) {
            Swal.fire('Error', 'Minimal harus ada 1 produk dengan jumlah kirim > 0', 'error');
            return;
        }

        isSavingShipment.value = true;
        try {
            const payload = {
                order_id: parseInt(orderId),
                source_id: parseInt(shipmentForm.source_id),
                tanggal_pengiriman: shipmentForm.tanggal_pengiriman,
                no_surat_jalan: shipmentForm.no_surat_jalan,
                notes: shipmentForm.notes,
                items: itemsToShip
            };

            await shipmentService.createShipment(payload);
            
            // Close modal by clicking the close button
            const closeBtn = document.querySelector('#shipment-modal .btn-close');
            if (closeBtn) closeBtn.click();
            
            // Reset form
            shipmentForm.source_id = "";
            shipmentForm.no_surat_jalan = "";
            shipmentForm.notes = "";
            shipmentForm.tanggal_pengiriman = new Date().toISOString().split('T')[0];
            
            // Reload data reactively (no page refresh)
            await loadData();
            
            // Toast notification
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Realisasi berhasil disimpan',
                showConfirmButton: false,
                timer: 2000,
                timerProgressBar: true
            });
        } catch (error) {
            console.error(error);
            Swal.fire('Error', 'Gagal menyimpan realisasi', 'error');
        } finally {
            isSavingShipment.value = false;
        }
    };

    const removeShipment = async (id) => {
        const result = await Swal.fire({
            title: 'Hapus Riwayat?',
            text: 'Data item akan dikembalikan ke sisa PO',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ya, Hapus',
            cancelButtonText: 'Batal'
        });

        if (result.isConfirmed) {
            try {
                await shipmentService.deleteShipment(id);
                
                // Reload data reactively (no page refresh)
                await loadData();
                
                // Toast notification
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'success',
                    title: 'Data pengiriman berhasil dihapus',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true
                });
            } catch (error) {
                Swal.fire('Error', 'Gagal menghapus data', 'error');
            }
        }
    };

    const statusBadgeClass = (status) => {
        switch(status) {
            case 'completed': return 'badge bg-success';
            case 'partial': return 'badge bg-warning text-dark';
            case 'processing': return 'badge bg-black text-white';
            case 'final': return 'badge bg-info';
            default: return 'badge bg-secondary';
        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "-";
        return new Date(dateStr).toLocaleDateString('id-ID', { 
            weekday: 'long', 
            day: '2-digit', 
            month: 'long', 
            year: 'numeric' 
        });
    };

    const formatDateShort = (dateStr) => {
        if (!dateStr) return "-";
        return new Date(dateStr).toLocaleDateString('id-ID', { 
            day: '2-digit', 
            month: 'short', 
            year: 'numeric' 
        });
    };

    const openShipmentModal = () => {
        const btn = document.createElement('button');
        btn.setAttribute('data-bs-toggle', 'modal');
        btn.setAttribute('data-bs-target', '#shipment-modal');
        document.body.appendChild(btn);
        btn.click();
        document.body.removeChild(btn);
    };

    const finalizeOrder = async () => {
        const result = await Swal.fire({
            title: 'Finalisasi PO?',
            text: 'Setelah difinalisasi, PO tidak bisa diedit lagi.',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Ya, Finalisasi',
            cancelButtonText: 'Batal'
        });

        if (result.isConfirmed) {
            try {
                await orderService.updateOrder(orderId, { status: 'processing' });
                await loadData();
                Swal.fire({ icon: 'success', title: 'PO berhasil difinalisasi', toast: true, position: 'top-end', timer: 2000, showConfirmButton: false });
            } catch (error) {
                Swal.fire('Error', 'Gagal memfinalisasi PO', 'error');
            }
        }
    };

    const forceClose = async () => {
        const result = await Swal.fire({
            title: 'Selesaikan PO?',
            text: 'Status akan diubah menjadi COMPLETED meskipun masih ada sisa item.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ya, Selesaikan',
            cancelButtonText: 'Batal'
        });

        if (result.isConfirmed) {
            try {
                await orderService.updateOrder(orderId, { status: 'completed' });
                await loadData();
                Swal.fire({ icon: 'success', title: 'PO berhasil diselesaikan', toast: true, position: 'top-end', timer: 2000, showConfirmButton: false });
            } catch (error) {
                Swal.fire('Error', 'Gagal menyelesaikan PO', 'error');
            }
        }
    };

    const deleteOrder = async () => {
        const result = await Swal.fire({
            title: 'Hapus PO?',
            text: 'Data yang dihapus tidak dapat dikembalikan!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Ya, Hapus',
            cancelButtonText: 'Batal'
        });

        if (result.isConfirmed) {
            try {
                await orderService.deleteOrder(orderId);
                Swal.fire({ 
                    icon: 'success', 
                    title: 'PO berhasil dihapus', 
                    toast: true, 
                    position: 'top-end', 
                    timer: 2000, 
                    showConfirmButton: false 
                });
                router.push('/purchases/order-list');
            } catch (error) {
                Swal.fire('Error', 'Gagal menghapus PO', 'error');
            }
        }
    };

    return {
        order,
        orderItems,
        shipments,
        shipmentForm,
        orderSources,
        filteredItemsForShipment,
        isSavingShipment,
        catatanLocal,
        isSavingNotes,
        calculatedStatus,
        router,
        validateQty,
        saveNotes,
        saveShipment,
        removeShipment,
        statusBadgeClass,
        formatDate,
        formatDateShort,
        openShipmentModal,
        finalizeOrder,
        forceClose,
        deleteOrder
    };
  }
};
</script>

<style scoped>
/* Desktop Styles */
.custom-date-input {
    border: 1px solid #d9d9d9 !important;
    box-shadow: none !important;
    height: 44px !important;
    display: flex;
    align-items: center;
}
.custom-date-input:hover, .custom-date-input:focus {
    border-color: #029147 !important;
}
:deep(.ant-picker-focused) {
    border-color: #029147 !important;
    box-shadow: 0 0 0 2px rgba(2, 145, 71, 0.2) !important;
}
:deep(.ant-picker-today-btn) {
    color: #029147 !important;
}
:deep(.ant-picker-active-bar) {
    background: #029147 !important;
}
:deep(.ant-btn-primary) {
    background-color: #029147 !important;
    border-color: #029147 !important;
}
.themed-datepicker {
    display: flex;
}
.themed-datepicker .input-group-text {
    border-right: 0;
    display: flex;
    align-items: center;
}
:deep(.ant-picker-dropdown) {
    z-index: 1100 !important;
}
.bg-light-soft {
    background-color: #f8f9fa;
}
.x-small {
    font-size: 11px;
}
.italic {
    font-style: italic;
}

/* Mobile Styles */
.mob-po-detail {
    background: #f8fafc;
    min-height: 100vh;
}
.btn-delete-mob {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #fff5f5;
  border: 1px solid #fee2e2;
  color: #ef4444;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-back-mob {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1e293b;
  border: 1px solid #f1f5f9;
  transition: all 0.2s;
}
.btn-back-mob:active {
  transform: scale(0.9);
  background: #f8fafc;
}

.mob-card {
    padding: 16px;
    border-radius: 20px;
    border: none !important;
}

.kios-avatar {
    width: 48px;
    height: 48px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.bg-success-soft { background: #ecfdf5; }

.mob-textarea {
    border: 1px solid #f1f5f9;
    background: white;
    border-radius: 12px;
    padding: 12px 15px;
    font-size: 14px;
    color: #000 !important;
}
.mob-textarea:focus {
    border-color: #029147;
    background: white;
    box-shadow: none;
}

.btn-add-pill {
    padding: 6px 12px;
    border-radius: 50px;
    border: none;
    font-size: 10px;
    font-weight: 800;
    display: flex;
    align-items: center;
    transition: transform 0.1s;
}
.btn-add-pill:active { transform: scale(0.95); }

.mob-progress-card {
    padding: 14px;
    border-radius: 16px;
    border: none !important;
}

.mob-history-card {
    padding: 14px;
    border-radius: 16px;
    border: none !important;
}

.shadow-xs {
    box-shadow: 0 4px 12px rgba(0,0,0,0.04);
}

.smallest { font-size: 10px; }
.uppercase { text-transform: uppercase; letter-spacing: 0.5px; }
.tracking-wider { letter-spacing: 1px; }
.fw-800 { font-weight: 800; }

/* Modal Mobile Styles */
.btn-close-mob {
    background: #f8fafc;
    border: none;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #64748b;
}

.mob-label {
    font-size: 11px;
    font-weight: 800;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.mob-input, .mob-select {
    border: 1px solid #f1f5f9;
    background: #f8fafc;
    border-radius: 12px;
    padding: 12px 15px;
    font-size: 14px;
}
.mob-input:focus, .mob-select:focus {
    border-color: #029147;
    background: white;
    box-shadow: none;
}

.mob-qty-input {
    border: 2px solid #e2e8f0;
    border-radius: 10px;
    padding: 8px;
    font-weight: bold;
    font-size: 16px;
}
.mob-qty-input:focus {
    border-color: #029147;
    box-shadow: none;
}

.mob-ship-item {
    transition: all 0.2s;
}

.spin {
    animation: spin 1s linear infinite;
}
@keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

@media (max-width: 991.98px) {
    .page-header { display: none !important; }
}
</style>
